module.exports = __webpack_public_path__ + "img/lanre-o.9118508e.png";